<div class="grid-container full-height full v-pad" [ngClass]="{ 'margin-bottom-x-large': showExpediteMessage }">
  @if (page && indexLoaded) {
    <form [formGroup]="ngForm" class="user-form-max-width" #container>
      @if (infiniteLoop) {
        <div class="grid-x">
          <div class="cell large-12 bold red">
            {{infiniteLoopMessage}}
          </div>
        </div>
      }
      @if (pageTitle != '') {
        <h2>{{pageTitle}}</h2>
      }
      @for (questionGroup of page.questions; track questionGroup; let i = $index) {
		<div class="question-row">
			@for (question of questionGroup; track question; let j = $index) {
			<!-- Diagnostic: Show if FormControl is missing -->
			@if (!ngForm.get(question.key)) {
			<span style="color:red">No FormControl for key: {{question.key}}</span>
			<pre>{{ question | json }}</pre>
			}
			<div class="question-cell" [ngStyle]="{'flex-grow': question.flexGrow || 1}" [style.--error-min-height]="getMaxValidationCount(questionGroup) * 1.25 + 'rem'">
				<ng-template dynamic-component-loader [componentName]="question.type" [componentData]="question"
							 [componentContext]="workflow.context" [formGroup]="ngForm" [flowComponent]="this">
				</ng-template>
				@if (ngForm.get(question.key).errors && ngForm.get(question.key).dirty || ngForm.get(question.key).touched) {
				<div class="error-container">
					@for (error of getErrors(ngForm.get(question.key).errors); track error) {
					<span class="error">{{error}}</span>
					}
				</div>
				}
			</div>
			}
		</div>
      }
      <div>
        @if (addAdhoc) {
          <add-ad-hoc-reviewer [workOrderId]="workItemId" [workflow]="workflow" (closeEvent)="toggleAdhoc($event)"></add-ad-hoc-reviewer>
        }
      </div>
      <div class="form-button-group margin-top">
        @for (button of page.specialButtons; track button; let last = $last) {
          @if (button?.visible()) {
            <button class="button hollow" [ngClass]="{'minor-margin-right': !last}"
              (click)="buttonClick(button)" [disabled]="isButtonDisabled(button) || buttonIsLocked">
              {{button.label}}
            </button>
          }
        }
      </div>
    </form>
    @if (showNavigationButtons) {
      @for (button of page.navigationButtons; track button) {
        @if (showNextButton(button)) {
          <button class="next-link vertical-middle" (click)="buttonClick(button)" [disabled]="disableNavigation || isButtonDisabled(button)">
            <span>{{button.label}}</span>
            <span class="next-link-span" aria-hidden="true">
              <svg-icon class="white" icon="icon-chevron-right"></svg-icon>
            </span>
          </button>
        }
        @if (showBackButton(button)) {
          <button class="back-link vertical-middle" [disabled]="disableNavigation || isButtonDisabled(button)" (click)="buttonClick(button)">
            <span class="back-link-span" aria-hidden="true">
              <svg-icon class="white" icon="icon-chevron-left"></svg-icon>
            </span>
            <span>{{button.label}}</span>
          </button>
        }
      }
    }
    <flow-sections [state]="state" [currentPage]="page" [isResuming]="returningUser && !isReviewForm" [sectionContext]="this.workflow.context.sections" [expediteSetting]="expediteSetting" [moduleConfig]="moduleConfig" [workflow]="workflow" (navigateSection)="navigateSection($event)"></flow-sections>
  } @else {
    <div class="user-form-max-width">
      <text-loader [run]="!indexLoaded" [tickType]="'.'" [text]="'Loading Flow Content'" [interval]="2000"></text-loader>
    </div>
  }
</div>

<a style="display: none;" #downloadLink></a>

<ng-template #noExpedites>
  <span [innerHTML]="noExpeditingMessage"></span>
</ng-template>